<template>
  <button
    :class="['question_btn', statusClass, {disabled: isDisabledClassApplied, selected }]"
    @click.prevent="handleAnswerSelect"
  >
    {{ text }}
  </button>
</template>

<script setup>
import { computed } from 'vue';

const emits = defineEmits(['select:answer']);

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  answered: {
    type: Boolean,
    default: false,
  },
  correct: {
    type: Boolean,
    default: false,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  userChosen: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isSelectedAndAnswered = computed(() => props.selected && props.answered);

const isSelectedByUser = computed(() => props.selected && props.userChosen);

const isDisabledClassApplied = computed(() =>
  props.disabled &&
  !isSelectedAndAnswered.value &&
  !isSelectedByUser.value,
);

const statusClass = computed(() => {
  if (isSelectedAndAnswered.value) {
    return props.correct ? 'right_answer' : 'wrong_answer';
  } else {
    return '';
  }
});

const handleAnswerSelect = (event) => {
  event?.target?.blur?.();

  if (props.disabled) { return; }

  emits('select:answer', { text: props.text });
};
</script>
